import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../components/Button';
import ConfirmModal from '../../../../../components/modals/ConfirmModal';
import styles from '../../../styles/SubscriptionContainer.module.scss';
import { inAppCancellation as events } from '../../../../../lib/analytics/events';

interface IRenewConfirmationModalProps {
  onContinue: () => void;
  pageName: string;
  petId: string;
  trigger?: React.ReactElement;
}

export default function RenewConfirmationModal({ onContinue, pageName, petId, trigger }: IRenewConfirmationModalProps) {
  const { t } = useTranslation();
  const onAccept = () => {
    events.renewConfirmationModalContinue({ petId }, pageName);
    onContinue();
  };
  const onDecline = () => {
    events.renewConfirmationModalGoBack({ petId }, pageName);
  };
  return (
    <ConfirmModal
      trigger={trigger ?? <Button className={styles.button}>{t('renew')}</Button>}
      body={
        <>
          <h2>{t('are_you_sure')}</h2>
          <p>{t('this_will_reactivate_your_fi_membership_and_you_will_be_billed_at_your_usual_renewal_date')}</p>
        </>
      }
      acceptText={t('yes_continue')}
      declineText={t('no_go_back')}
      onAccept={onAccept}
      onDecline={onDecline}
    />
  );
}
